import React from 'react';
import PageLoadingMask from 'components/masks/PageLoadingMask';

function LoadingSpinner(props) {
  return (
    <div data-testid="spinner" className="redirect-wrapper LoadingSpinner">
      <PageLoadingMask {...props} />
    </div>
  );
}

export default LoadingSpinner;
